export const isValidURL = (texto) => {
  try {
    new URL(texto);
    return true;
  } catch (e) {
    return false;
  }
};



// WEBPACK FOOTER //
// ./src/utils/isValidURL.js